import clsx from "clsx";

export default function PrimaryButton({
  children,
  className = "",
  ...props
}) {
  return (
    <button
      {...props}
      className={clsx(
        "flex items-center gap-2 rounded-xl px-5 py-3",
        "font-semibold text-white transition-all",
        "bg-gradient-to-r from-green-500 to-green-600",
        "hover:from-green-600 hover:to-green-700",
        "shadow-[0_0_20px_rgba(34,197,94,.45)]",
        className
      )}
    >
      {children}
    </button>
  );
}